import React, { useState, useEffect, useRef } from "react";
import { IoIosSearch, IoIosArrowRoundBack } from "react-icons/io";
import { LuPlus } from "react-icons/lu";
import { CiEdit } from "react-icons/ci";
import { IoCloseOutline } from "react-icons/io5";
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";
import PropTypes from "prop-types";
// import "./Table.css";
import { useNavigate } from "react-router-dom";
import { CiMenuBurger } from "react-icons/ci";
import axiosInstance from "../axiosinstance";

function ArchivedFirms({ isSidebarExpanded }) {
  const [Firms, setFirms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedFirms, setSelectedFirms] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isDeletePopup, setIsDeletePopup] = useState(false);
  const [isSortPopup, setIsSortPopup] = useState(false);
  const containerRef = useRef(null);
  const [searchVisible, setSearchVisible] = useState(false); // Toggle search bar
  const [searchQuery, setSearchQuery] = useState(""); // Store search input
  const navigate = useNavigate();
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" });
  const [isChecked, setChecked] = useState(false);

  const fetchData = async (status = "Archive") => {
    try {
      setLoading(true);

      const response = await axiosInstance.get(
        `/api/get_active_firm?page_status=${status}`
      );
      setFirms(response.data.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching firm data:", error.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData("Archive"); // Pass "active" as an argument
  }, []);

  function handleUser() {
    navigate("/Admin-form");
  }

  function handleEdit(id) {
    navigate(`/Edit-Firms/${id}`);
  }

  const handleCheckboxChange = (firmId) => {
    setSelectedFirms((prevSelected) =>
      prevSelected.includes(firmId)
        ? prevSelected.filter((id) => id !== firmId)
        : [...prevSelected, firmId]
    );
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedFirms([]);
    } else {
      setSelectedFirms(Firms.map((firm) => firm.firm_id));
    }
    setSelectAll(!selectAll);
  };

  useEffect(() => {
    setSelectAll(selectedFirms.length === Firms.length && Firms.length > 0);
  }, [selectedFirms, Firms]);

  //   const handleDeletePopup = () => {
  //     setIsDeletePopup(true);

  const handleRestoreUser = async () => {
    try {
      const response = await axiosInstance.put(`/api/unarchive_firm`, {
        ids: selectedFirms,
      });

      if (response.status === 200) {
        fetchData();
        navigate("/super-Admin");
        setSelectAll(false);
        setChecked(false);
      } else {
        console.error("Failed to restore departments");
      }

      if (response.ok) {
        // showSnackbar("Department restored successfully");
        fetchData();
        navigate("/super-Admin");
        setSelectAll(false);
        setChecked(false);
      } else {
        console.error("Failed to restore departments");
      }
    } catch (error) {
      console.error("An error occurred while restoring departments:", error);
    }
  };

  const handleCancel = () => {
    setIsDeletePopup(false);
  };

  const handleSearch = async (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    if (query.trim() === "") {
      fetchData();
    } else {
      try {
        const response = await axiosInstance.get(`/api/search_firms`, {
          params: { query, page_status: "Archive" },
        });

        setFirms(response.data.data || []);
      } catch (error) {
        console.error("Error fetching search results:", error.message);
      }
    }
  };

  const handleSort = (key) => {
    // If the same column is clicked again, toggle the direction.
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }

    const sortedClients = [...Firms].sort((a, b) => {
      const aValue =
        key === "contact_details" && a.contact_details?.length
          ? a.contact_details[0].contact_name.toLowerCase()
          : a[key];

      const bValue =
        key === "contact_details" && b.contact_details?.length
          ? b.contact_details[0].contact_name.toLowerCase()
          : b[key];

      // Compare the values and return the sort order.
      if (aValue < bValue) return direction === "asc" ? -1 : 1;
      if (aValue > bValue) return direction === "asc" ? 1 : -1;
      return 0;
    });

    // Update the sort configuration and set the sorted clients
    setSortConfig({ key, direction });
    setFirms(sortedClients);
  };
  const handleSortpopup = () => {
    setIsSortPopup(!isSortPopup);
  };

  return (
    <div
      className={`table-container ${
        isSidebarExpanded ? "expanded" : "collapsed"
      }`}
    >
      {/* Table Header (Conditional) */}
      <div className="table-header">
        {selectedFirms.length > 0 ? (
          <div className="table-header-content archive-header">
            <button className="delete" onClick={handleRestoreUser}>
              Unarchive
            </button>
            <button
              className="action-header-close-button"
              onClick={() => setSelectedFirms([])}
            >
              <IoCloseOutline className="action-header-close-icon" />
            </button>
          </div>
        ) : (
          <div className="table-header-content">
            <div className="table-left-side">
              <div
                onClick={() => navigate(-1)} // Navigate back to the previous page
                className="back-button"
              >
                <IoIosArrowRoundBack />
              </div>
              <h2 className="jost-bold">Archived Firms</h2>
            </div>
            <div className="table-right-side">
              <div
                className={`search-icon ${searchVisible ? "no-border" : ""}`}
                onClick={() => setSearchVisible(!searchVisible)}
              >
                <IoIosSearch />
              </div>
              <div className="new-button" onClick={handleUser}>
                <span className="new-icon">
                  <LuPlus />
                </span>
                <span>New</span>
              </div>
              <button className="sort-button" onClick={handleSortpopup}>
                <CiMenuBurger className="sort-icon" />
              </button>
              {isSortPopup && (
                <div className="sort-popup-container" ref={containerRef}>
                  <div className="sort-popup-header">
                    <span className="sort-title">Sort By</span>
                  </div>
                  <div className="sort-popup-content">
                    <button
                      className="sort-button sort-button-options"
                      onClick={() => handleSort("firm_name")}
                    >
                      Company Name
                    </button>
                    <button
                      className="sort-button sort-button-options"
                      onClick={() => handleSort("address")}
                    >
                      Location
                    </button>
                    <button
                      className="sort-button sort-button-options"
                      onClick={() => handleSort("owner_name")}
                    >
                      Owner Name
                    </button>
                    <button
                      className="sort-button sort-button-options"
                      onClick={() => handleSort("max_subsidiaries")}
                    >
                      Max Subsidiaries
                    </button>
                  </div>
                </div>
              )}
              <div
                className={`search-bar ${searchVisible ? "visible" : "hidden"}`}
              >
                <input
                  type="text"
                  placeholder="Search Invoice..."
                  value={searchQuery}
                  onChange={handleSearch} // Use handleSearch to update search query and filter data
                />
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Delete Confirmation Popup */}
      {/* {isDeletePopup && (
        <div className="confirm-delete-popup">
          <div className="confirm-delete-popup-content">
            <div className="confirm-model">
              <div className="confirm-model-content">
                <div className="confirm-model-content-body">
                  <p>Are you sure you want to move to archive?</p>
                </div>
                <div className="confirm-model-content-footer">
                  <button
                    className="confirm-delete-button"
                    onClick={handleArchiveFirms}
                  >
                    Yes
                  </button>
                  <button
                    className="confirm-cancel-button"
                    onClick={handleCancel}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )} */}

      {/* Table Content */}
      <div className="table-container-content form-main-body">
        <div className="data-list-body">
          <div className="data-list-scroll-body">
            <div className="data-list-table">
              {loading ? (
                <div className="loading-spinner">Loading...</div>
              ) : (
                <table className="table multilevel-data">
                  <thead>
                    <tr className="table-row">
                      <th>
                        <input
                          type="checkbox"
                          checked={selectAll}
                          onChange={handleSelectAll}
                        />
                      </th>
                      <th>Se. No</th>
                      <th>Company Name</th>
                      <th>Location</th>
                      <th>Owner</th>
                      <th>No of Subsidiaries</th>
                      <th>Contact No</th>
                      <th>Email ID</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody className="data-list-scroll-bodys">
                    {Firms.length > 0 ? (
                      Firms.map((firm) => (
                        <tr key={firm.firm_id} className="hoverable-row">
                          <td className="center-align">
                            <input
                              type="checkbox"
                              checked={selectedFirms.includes(firm.firm_id)}
                              onChange={() =>
                                handleCheckboxChange(firm.firm_id)
                              }
                            />
                          </td>
                          <td className="center-align">{firm.serial_number}</td>
                          <td className="center-align">{firm.firm_name}</td>
                          <td className="center-align">{firm.address}</td>
                          <td className="center-align">{firm.owner_name}</td>
                          <td className="center-align">
                            {firm.max_subsidiaries}
                          </td>
                          <td className="center-align">{firm.contact_no}</td>
                          <td className="center-align">{firm.email_id}</td>
                          <td className="center-align">
                            <div
                              className="action-btn"
                              onClick={() => handleEdit(firm.firm_id)}
                            >
                              <span className="action-icon">
                                <CiEdit />
                              </span>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="9" className="center-align">
                          No firms available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ArchivedFirms;
